module.exports = __webpack_public_path__ + "static/media/img-poster-fg@2x.6f172bfc.png";